<div class="project-selection-header">
    <sc-padding>
        <sc-flex [stretchContent]="true">
            <ng-container *ngFor="let title of projectTitles, let i = index">
                <sc-content-spacer *ngIf="i>0"></sc-content-spacer>
                <app-project-selection-header-tab-item [projectTitle]="title" [selected]="isProjectSelected(title.id)"
                    (close)="closeProject($event)"
                    (select)="selectProject($event)"></app-project-selection-header-tab-item>
            </ng-container>
            <sc-content-spacer [grow]="true"></sc-content-spacer>
            <button mat-icon-button class="options-icon-button" (click)="selectOrCreateProject()">
                <sc-icon iconClass="fa-plus"></sc-icon>
            </button>
        </sc-flex>
    </sc-padding>
</div>